import PropTypes from 'prop-types';
import React from 'react';
import withTranslate from '../../hoc/with-translate';
import classNames from 'classnames';
import styles from './post-stats.scss';

function PostStats({ viewCount, commentCount, t, type }) {
  return (
    <div
      className={classNames({
        [styles.counter]: type === PostStats.DEFAULT,
        [styles.counterMemberArea]: type === PostStats.MEMBER_AREA,
      }, 'post-stats')}
    >
      <span className={classNames(styles.viewCount)} data-hook="post-stats__view-count">
        {t('post-stats.view-count', { count: viewCount })}
      </span>
      <span className={classNames(styles.commentCount)} data-hook="post-stats__comment-count">
        {t('post-stats.comment-count', { count: commentCount })}
      </span>
    </div>
  );
}

PostStats.DEFAULT = 'default';
PostStats.MEMBER_AREA = 'memberArea';

PostStats.propTypes = {
  commentCount: PropTypes.number.isRequired,
  viewCount: PropTypes.number.isRequired,
  t: PropTypes.func,
  type: PropTypes.string,
};

PostStats.defaultProps = {
  commentCount: 0,
  viewCount: 0,
  type: PostStats.DEFAULT,
};

export default withTranslate(PostStats);



// WEBPACK FOOTER //
// ./app/components/post-stats/post-stats.js